<template>
  <div
    id="dashboard-info-modal"
    class="dashboard-info-modal"
  >
    <modal
      ref="dashboardInfoModal"
      template="neutral"
      title="Bem-vindo à Rastreabilidade de amostras!"
      ref-name="dashboardInfoModal"
      :icon-enabled="false"
      :close-button-enabled="false"
      class="dashboard-info-modal"
    >
      <p>A partir de agora você poderá acompanhar o status das suas amostras de ponta a ponta!</p>

      <hr>

      <md-layout md-flex="100">
        <md-layout
          class="new"
          md-flex="50"
        >
          <h4>Acompanhe um resumo do que foi enviado</h4>
          <img
            class="media"
            src="/static/images/image-traceability-dash.png"
            alt="Screenshot do novo Dashboard"
          >
          <hr>
          <md-button
            class="btn btn-primary modal"
            @click="openPDF()"
          >
            Entenda no detalhe seu funcionamento
          </md-button>
        </md-layout>
        <br>
        <md-layout
          class="new"
          md-flex="50"
        >
          <h4>Pesquise e acompanhe as amostras enviadas</h4>
          <img
            class="media"
            src="/static/images/image-traceability-map.png"
            alt="Screenshot do mapa com rastreabilidade"
          >
          <hr>
          <!--
           <md-button class="btn btn-primary modal"
           @click="openVideoTutorialModal()">Veja nosso vídeo tutorial.</md-button>
           -->
        </md-layout>
        <br>
        <div class="standard-modal__container-dismiss">
          <md-button
            class="btn btn-dismiss-purple center"
            @click="closeInfoModal()"
          >
            {{ 'Ver mais tarde' }}
          </md-button>
        </div>
      </md-layout>
    </modal>

    <modal
      ref="videoTutorialModal"
      template="neutral"
      icon-type="back"
      :icon-enabled="true"
      :header-clickable="true"
      ref-name="videoTutorialModal"
      title="Video Tutorial"
      :close-button-enabled="true"
      @header-action="closeVideoTutorialModal()"
    >
      <video
        width="800"
        controls
      >
        <source
          src="https://storageapoiob2bprd.blob.core.windows.net/dashboard/tutorial.mp4"
          type="video/mp4"
        >
        Seu navegador não suporta vídeos em HTML5. Atualize para uma versão mais recente.
      </video>
    </modal>

    <modal
      ref="pendencyAlertModal"
      template="neutral"
      class="pendency-modal"
      ref-name="pendencyAlertModal"
      title="Pendencias não respondidas"
      :close-button-enabled="true"
      @header-action="closePendencyAlertModal()"
    >
      ATENÇÃO! Você possui registros de pendência não respondidas.
      <br>
      Para respondê-las e evitar o atraso na execução de
      seus exames, <span
        class="redirect-button"
        @click="redirectToPendency"
      >clique aqui</span>
    </modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DashboardInfoModal',
  data: () => {
    return {
      firstTimeAtNewDashboard: false,
      userSawThePendencyAlert: false
    }
  },
  methods: {
    ...mapActions(['editUserPreference']),
    openInfoModal() {
      this.$refs.dashboardInfoModal.open()
    },
    openPDF() {
      window.open('https://storageapoiob2bprd.blob.core.windows.net/dashboard/rastreabilidade.pdf')
    },
    closeInfoModal() {
      this.$refs.dashboardInfoModal.close()
      this.$emit('modal-closed')
    },
    openVideoTutorialModal() {
      this.$refs.videoTutorialModal.open()
    },
    closeVideoTutorialModal() {
      this.$refs.videoTutorialModal.close()
    },
    openPendencyAlertModal() {
      const today = new Date().toLocaleDateString()
      const lastSeenDate = localStorage.getItem('lastSeenPendencyAlert')
      if (!lastSeenDate || lastSeenDate !== today) {
        this.$refs.pendencyAlertModal.open()
        localStorage.setItem('lastSeenPendencyAlert', today)
        this.userSawThePendencyAlert = true
      }
    },
    closePendencyAlertModal() {
      this.$refs.pendencyAlertModal.close()
    },
    redirectToPendency() {
      this.$router.replace('/pendencies/list')
      this.closePendencyAlertModal()
    }
  }
}
</script>

<style lang="scss">
.dashboard-info-modal .md-dialog {
  width: 810px;
  max-height: 90%;
  .size-medium .md-dialog {
    min-height: 140px;
  }
  .standard-modal__container-dismiss {
    margin-top: 12px;
  }

  .standard-modal__title {
    font-weight: 300;
    font-size: 34px;
    line-height: 26px;
    color: #7f1a54;
  }
  p {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 18px;
    color: #7a7a7a;
  }

  .new {
    display: flex;
    flex-direction: column;
  }

  .modal {
    width: 95%;
    margin-top: 5px;
    margin-left: 200px;
  }
  h4 {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    color: #87003f;
    margin-left: 11%;
  }

  hr {
    border: 1px solid #d8d8d8;
    margin: 19px 0;
  }

  .media {
    padding-top: 10px;
    padding-right: 17px;
    width: 100%;
  }
}

#dashboardInfoModal {
  z-index: 1000;
}

#pendencyAlertModal {
  .standard-modal__title {
    display: block;
    pointer-events: none;
    .md-icon {
      min-width: 18px;
      width: 18px;
    }
  }
  .redirect-button {
    color: #7f1a54;
    font-weight: 500;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}

</style>
